import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import CustomInputComponent from "./CustomInput";
import { Formik, Form, Field, FieldArray } from "formik";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { useMediaQuery } from "@mui/material";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import { translate } from "../../utils/utils";
import { Grid } from "@mui/material";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import SaveAsOutlinedIcon from "@mui/icons-material/SaveAsOutlined";
import Divider from "@mui/material/Divider";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#F3FBF9",
    color: "#B1B4BC",
    height: "50px",
    padding: "0px 16px 0px 16px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {},
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function BrowseQuestions({
  open,
  handleClose,
  index,
  setFieldValue,
  values,
  lang,
}) {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width:800px)");

  return (
    <div>
      <Dialog
        open={open}
        onClose={() => {
          handleClose();
        }}
        maxWidth="xl"
        PaperProps={{
          sx: { width: "65%", padding: "20px " },
        }}
      >
        <Typography
          variant="subtitle3"
          sx={{ display: "flex", alignItems: "center", mb: 1 }}
        >
          <IconButton
            onClick={() => {
              handleClose();
            }}
          >
            <KeyboardBackspaceIcon sx={{ width: "70%", color: "black" }} />
          </IconButton>
          {t("back")}
        </Typography>
        <DialogTitle>
          <Typography variant="title4">{t("translate_question")}</Typography>
        </DialogTitle>
        <DialogContent>
          <div>
            <Grid container spacing={2} sx={{ padding: "20px" }}>
              <Grid item xs={12}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span
                    style={{
                      fontSize: "20px",
                      fontFamily: "Bebas Neue",
                    }}
                  >
                    Question {index + 1}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12}>
                <>
                  {isMobile ? (
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <Field
                          placeholder={t("type_question")}
                          name={lang === "en" ? "title_fr" : "title"}
                          component={CustomInputComponent}
                          type="text"
                        />
                      </Grid>
                    </Grid>
                  ) : (
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <Field
                          placeholder={t("type_question")}
                          name={lang === "en" ? "title_fr" : "title"}
                          component={CustomInputComponent}
                          type="text"
                        />
                      </Grid>
                    </Grid>
                  )}
                </>
              </Grid>
            </Grid>

            <Divider />
            <Grid container spacing={1} sx={{ padding: "20px" }}>
              <Grid item xs={12} marginBottom="20px">
                <span style={{ color: "grey", fontWeight: 600 }}>
                  {t("answers")}
                </span>
              </Grid>

              <FieldArray name="choices">
                {() =>
                  values?.choices?.map((ticket, i) => {
                    return (
                      <Grid
                        container
                        spacing={isMobile ? 2 : 7}
                        sx={{
                          padding: "5px",
                          fontSize: isMobile ? "12px" : "15px",
                        }}
                        key={i}
                        wrap={"wrap"}
                      >
                        <>
                          <Grid item xs={12}>
                            <Field
                              placeholder={t("type_answer")}
                              name={
                                lang === "en"
                                  ? `choices.${i}.title_fr`
                                  : `choices.${i}.title`
                              }
                              component={CustomInputComponent}
                              type="text"
                            />
                          </Grid>
                        </>
                      </Grid>
                    );
                  })
                }
              </FieldArray>
            </Grid>

            <>
              <div
                style={{
                  padding: "10px 20px",
                  textAlign: "end",
                  display: isMobile ? "flex" : {},
                }}
              >
                <Button
                  onClick={() => {
                    handleClose();

                    if (lang === "en") {
                      setFieldValue("title_fr", "");
                    } else {
                      setFieldValue("title", "");
                    }
                    setFieldValue(
                      "choices",
                      lang === "en"
                        ? values?.choices?.map((el) => ({
                            ...el,
                            title_fr: "",
                          }))
                        : values?.choices?.map((el) => ({ ...el, title: "" }))
                    );
                  }}
                  size="small"
                  color="primary"
                  variant="outlined"
                  style={{
                    marginRight: "10px",
                    width: isMobile ? "50%" : {},
                  }}
                >
                  {t("remove")}
                </Button>
                <Button
                  size="small"
                  onClick={() => handleClose()}
                  color="secondary"
                  variant="contained"
                  startIcon={<SaveAsOutlinedIcon />}
                  style={{
                    marginRight: "10px",
                    width: isMobile ? "50%" : {},
                  }}
                >
                  {t("save")}
                </Button>
              </div>
            </>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
